import { ExportCrmSettingsInterface } from './interface';
import { ExportTypeEnum } from '../../enums';
import { Observable } from 'rxjs';
import { BaseApiService } from '../api';

export abstract class AbstractCrmService implements ExportCrmSettingsInterface {

  constructor(protected readonly baseApiService: BaseApiService) {

  }

  getExportCrmSettingsUrl(){
    return `service/contactcloud/techIntel/crm/settings?crmName=${this.getExportType()}`;
  }

  getExportCrmSettings(): Observable<any> {
    return this.baseApiService.get(this.getExportCrmSettingsUrl());
  }

  saveExportCrmSettings(settings: any): Observable<any> {
    return this.baseApiService.put(this.getExportCrmSettingsUrl(), settings);
  }

  abstract getExportType(): ExportTypeEnum;
}
